module.exports = __webpack_public_path__ + "img/level2addon_mining_tool_mask.5cb73d2b.png";